<template>
  <div class="vgsi_panel_btn">
    <div class="vgsi_btn">
      <a
        href="#"
        title=""
        class="vgsi_btn_link"
        @click.prevent="clickHandle()"
      >
        <span>
          <slot />
        </span>
      </a>
    </div>
    <div class="vgsi_btn__label">{{ propButtonLabel }}</div>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: {
    propButtonLabel: {
      type: String,
      default: '',
      required: true
    }
  },
  methods: {
    clickHandle () {
      this.$emit('buttonClick')
    }
  }
}
</script>

<style lang="scss">
$blue-color: #006893;
$btn-size: 46px;
$btn-border-size: 8px;
$l: 6.25em;
$bw: .1*$l;
$sh: radial-gradient( rgba(#787878, .9), rgba(#787878, 0) 70% ) 50% bottom / 80% .75*$bw no-repeat border-box;
$hl: inset 0  1px 2px rgba(#fff, .5), inset 0 -1px 2px rgba(#000, .5);

.vgsi_panel_btn {
  width: 50%;
  display: block;
  text-align: center;
  margin-bottom: 2.083vw;
  &.has-svg-icon {
    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
}
.vgsi_btn_link {
  background: #D1D1D1;
  // box-shadow: inset 0 0 0 1px #c9c9c9, $hl;
  background:
    conic-gradient(
        #d7d7d7, #c3c3c3, #cccccc, #c6c6c6,
        #d3d3d3, #d8d8d8, #d5d5d5, #d8d8d8,
        #d3d3d3, #c5c5c5, #c0c0c0, #bfbfbf,
        #d0d0d0, #d9d9d9, #d1d1d1, #c5c5c5,
        #c8c8c8, #d7d7d7, #d5d5d5, #cdcdcd,
        #c4c4c4, #d9d9d9, #cecece, #c5c5c5,
        #c5c5c5, #cdcdcd, #d8d8d8, #d9d9d9,
        #d7d7d7) content-box,
    linear-gradient(#d4d4d4, #d4d4d4)
    padding-box, $sh;
  color: #000;
  display: inline-block;
  font-weight: bold;
  font-size: 28px;
  width: $btn-size;
  height: $btn-size;
  border-radius: 50%;
  border: 1px solid #fff;
  line-height: $btn-size - 2;
  transition: all 550ms ease;
  position: relative;
  &:before {
    border-radius: 100%;
    content: '';
    display: block;
    background-image: linear-gradient(to bottom, #ffffff 0%, #D3D3D3 100%);
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.15);
    padding: 6px;
    width: $btn-size;
    height: $btn-size;
    top: -6px;
    left: -6px;
    position: absolute;
    z-index: -1;
  }
  &:hover, &:active, &:focus{
    background:$blue-color;
    background-image: linear-gradient(to bottom, $blue-color 0%, $blue-color 100%);
    color: #fff;
    &:before {
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
    }
  }
  span {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // text-shadow: hsla(0,0%,40%,.5) 0 -1px 0, hsla(0,0%,100%,.6) 0 2px 1px;
  }
}
.vgsi_btn__label {
  font-weight: bold;
  font-size: 13px;
  color: #374348;
  text-transform: uppercase;
  padding: 5px 19%;
  line-height: 1.2;
}
/*--custom--*/
.vgsi_panel_btn{
  &.is-hotline {
    .vgsi_btn_link {
      background: #FF3B00;
      border-color: transparent;
      svg { fill: #fff }
      &:before {
        background-image: linear-gradient(to bottom, #D65510 0%, #C14300 100%);
      }
    }
  }
  &.is-current:not(.is-hotline){
    .vgsi_btn_link {
      background: $blue-color;
      background-image: linear-gradient(to bottom, $blue-color 0%, $blue-color 100%);
      color: #fff;
    }
  }
  &.btn-4{
    .vgsi_btn__label{ padding-left: 25%; padding-right: 25% }
  }
}
</style>
